module.exports = __webpack_public_path__ + "media/src/img/youtube-icon-blue-c7e92666c6030bb45891899451682d8e.svg";